import { render, staticRenderFns } from "./AddPrivilegeList.vue?vue&type=template&id=97f219c6&"
import script from "./AddPrivilegeList.vue?vue&type=script&lang=js&"
export * from "./AddPrivilegeList.vue?vue&type=script&lang=js&"
import style0 from "./AddPrivilegeList.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports